import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfiguracoesDataService } from '../../../pages/perfil-usuario/shared/services/ConfiguracoesController/configuracoes-data.service';
import { NbGlobalLogicalPosition, NbToastrService } from '@nebular/theme';
import { getMenuMapByTitle } from '../../../pages/pages-menu';

interface Atalho {
  titulo: string;
  rota: string;
  icone: string;
  categoria?: string;
}

@Component({
  selector: 'ngx-assistente-virtual',
  templateUrl: './assistente-virtual.component.html',
  styleUrls: ['./assistente-virtual.component.scss']
})
export class AssistenteVirtualComponent implements OnInit, OnDestroy {
  logicalPositions = NbGlobalLogicalPosition;
  menuAberto: boolean = false;

  atalhos: Atalho[] = [];

  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private configuracoesDataService: ConfiguracoesDataService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    this.carregarListaAtalhos();
    this.configuracoesDataService.AtalhosAtualizados
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.carregarListaAtalhos());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleMenu(): void {
    this.menuAberto = !this.menuAberto;
  }

  navegarPara(rota: string): void {
    this.router.navigate([rota]);
    this.menuAberto = false;
  }

  getAtalhosPorCategoria(categoria: string): Atalho[] {
    return this.atalhos.filter(a => a.categoria === categoria);
  }

  getCategorias(): string[] {
    const categorias = ['principal', 'ai', 'utilidades'];
    // Retorna apenas categorias que têm atalhos
    return categorias.filter(cat => this.getAtalhosPorCategoria(cat).length > 0);
  }

  getNomeCategoria(categoria: string): string {
    const nomes: { [key: string]: string } = {
      'principal': 'PRINCIPAIS',
      'ai': 'RENOVERSE AI',
      'utilidades': 'UTILIDADES'
    };
    return nomes[categoria] || categoria;
  }

  carregarListaAtalhos(): void {
    const menuPorTitulo = getMenuMapByTitle();
    // Perfil não está em pages-menu (é menu do header); incluir caminho manualmente
    menuPorTitulo.set('Perfil', {
      link: '/pages/perfil-usuario',
      icon: 'person-outline',
      categoria: 'principal'
    });

    this.configuracoesDataService.CarregarListaAtalhos().subscribe(
      value => {
        if (value?.success && Array.isArray(value.data)) {
          const naoEncontrados: string[] = [];
          this.atalhos = value.data
            .map((item: { SubMenuDescricao?: string }) => {
              const titulo = item.SubMenuDescricao?.trim();
              if (!titulo) return null;
              const menuItem = menuPorTitulo.get(titulo);
              if (!menuItem) {
                naoEncontrados.push(titulo);
                return null;
              }
              return {
                titulo,
                rota: menuItem.link,
                icone: menuItem.icon,
                categoria: menuItem.categoria
              } as Atalho;
            })
            .filter((a): a is Atalho => a !== null);

          if (naoEncontrados.length > 0) {
            this.toastrService.warning(
              `${naoEncontrados.length} atalho(s) não encontrado(s) no menu: ${naoEncontrados.slice(0, 3).join(', ')}${naoEncontrados.length > 3 ? '...' : ''}`,
              'Atalhos ignorados',
              { position: this.logicalPositions.TOP_END }
            );
          }
        } else {
          this.atalhos = [];
          const msg = value?.error?.Message ?? value?.error?.message ?? value?.message ?? 'Erro ao carregar lista de atalhos';
          this.toastrService.danger(msg, 'Erro', { position: this.logicalPositions.TOP_END });
        }
      },
      err => {
        this.atalhos = [];
        this.toastrService.danger(
          err.error?.Message ?? err.error?.message ?? err.message ?? 'Erro ao carregar lista de atalhos',
          'Erro',
          { position: this.logicalPositions.TOP_END }
        );
      }
    );
  }
}
